import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModuleHeader from '@components/ModuleHeader';
import ScrollList from '@components/custom/ScrollList';
import Spinner from '@components/custom/Spinner';
import Table from '@components/custom/Table';

import '@assets/css/pricing.css';

import { crudActions } from '@sm/services/crudActions';
import { showAlert } from '@sm/store/alertSlice';

const Pricing = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [depositPricing, setDepositPricing] = useState([]);
  const [payoutPricing, setPayoutPricing] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [currencies, setCurrencies] = useState([]);
  const [merchantId, setMerchantId] = useState(null);

  const depositColumns = [
    {
      value: "paymentMethod",
      label: "Payin Method",
      leftAligned: true,
      isNumber: false,
      width: "10%"
    },
    {
      value: "trafficType",
      label: "Traffic",
      centerAligned: true,
      isNumber: false,
      width: "10%"
    },
    {
      value: "processingFee",
      label: "Payin Fee",
      rightAligned: true,
      isNumber: false,
      width: "10%"
    },
    {
      value: "txFee",
      label: "TX Fee",
      rightAligned: true,
      isNumber: false,
      width: "7%"
    },
    {
      value: "settlementFee",
      label: "Settlement Fee",
      rightAligned: true,
      isNumber: false,
      width: "10%"
    }, {
      value: "tx",
      label: "D+X",
      rightAligned: true,
      isNumber: true,
      width: "7%"
    }
  ];

  const payoutColumns = [
    {
      value: "paymentMethod",
      label: "Payout Method",
      leftAligned: true,
      isNumber: false,
      width: "10%"
    }, {
      value: "test",
      label: "",
      rightAligned: true,
      isNumber: true,
      width: "10%"
    }, {
      value: "processingFee",
      label: "Payout Fee",
      rightAligned: true,
      isNumber: true,
      width: "10%"
    }, {
      value: "txFee",
      label: "TX Fee",
      rightAligned: true,
      isNumber: true,
      width: "7%"
    }, {
      value: "test1",
      label: "",
      rightAligned: true,
      isNumber: true,
      width: "7%"
    }, {
      value: "test2",
      label: "",
      rightAligned: true,
      isNumber: true,
      width: "10%"
    }];

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    crudActions.get('v1/clients/lookups/balances')
      .then(response => {
        if (isMounted && response) {
          setCurrencies(response?.localCurrencies);
          setSelectedCurrency(response?.localCurrencies?.[0]?.value);
          setMerchantId(response?.merchantId);
        }
      })
      .catch(err => {
        if (isMounted) {
          dispatch(showAlert('danger', err?.message));
        }
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!selectedCurrency) return;

    setIsLoading(true);
    crudActions.get(`v2/clients/dashboard/display-deals?clients=${merchantId}&currency=${selectedCurrency}`)
      .then(response => {
        setDepositPricing(response?.depositDeals);
        setPayoutPricing(response?.payoutDeals);
        setIsLoading(false);
      })
      .catch(err => {
        dispatch(showAlert('danger', err?.message));
        setIsLoading(false);
      });
  }, [merchantId, selectedCurrency, dispatch]);

  const prepareTableData = (data) => {
    if (!data) {
      return [];
    }
    const groups = {};

    data.forEach(item => {
      const groupKey = [
        item.paymentMethod,
        item.processingFee,
        item.txFee,
        item.settlementFee,
        item.tx
      ].join('|');

      if (!groups[groupKey]) {
        groups[groupKey] = {
          paymentMethod: item.paymentMethod,
          trafficType: item.trafficType || '',
          processingFee: item.processingFee,
          txFee: item.txFee,
          settlementFee: item.settlementFee,
          tx: item.tx,
          childNodes: []
        };
      }
    });

    Object.values(groups).sort((a, b) =>
      a.trafficType.localeCompare(b.trafficType, 'en', { sensitivity: 'base' })
    );

    return Object.values(groups).sort((a, b) =>
      a.paymentMethod.localeCompare(b.paymentMethod, 'en', { sensitivity: 'base' })
    );
  };

  return (
    <div className='col-12 module finances pricing'>
      <div className='component shadow mb-4 position-relative'>
        <ModuleHeader
          id='api'
          title='Pricing'
          actions={
            <ScrollList
              items={ currencies }
              selectedItem={ selectedCurrency }
              onClick={ (value) => setSelectedCurrency(value) }
            />
          }
        />

        {isLoading && <Spinner /> }

        <Table
          className="overflow-table accordion-table mt-4"
          columns={ depositColumns }
          data={ prepareTableData(depositPricing) }
          disableSort
        />

        <Table
          className="overflow-table accordion-table mt-4"
          columns={ payoutColumns }
          data={ prepareTableData(payoutPricing) }
          disableSort
        />

      </div>
    </div>
  );
};

export default Pricing;